require('./bootstrap');

$(".loading").hide();